var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { css, jsx } from '@emotion/react';
import { Spacer, VisuallyHidden, ZapierLogo } from '@zapier/design-system';
import { labelStyles } from '@zapier/style-encapsulation';
import { FALLBACK_TOP_NAV_RESPONSE, UNIVERSAL_TOPBAR_CONDENSED_HEIGHT, UNIVERSAL_TOPBAR_HEIGHT, skipLinkHref as skipLinkHrefDefault, } from '../../constants';
import { useUniversalNavContext } from '../../hooks';
import SkipLink from '../SkipLink';
import UniversalTopbarLink from '../UniversalTopbar/UniversalTopbarLink';
import AccountActions from '../UniversalTopbar/AccountActions';
import SearchForm from '../UniversalTopbar/SearchForm';
const Styles = labelStyles('TopbarLoadingState', {
    root: [
        {
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: `var(--zds-background-weaker, #FFFDF9)`,
            position: 'relative',
            borderBottom: `1px solid var(--zds-gray-warm-3, #ECE9DF)`,
        },
    ],
    header: css({
        width: '100%',
        height: UNIVERSAL_TOPBAR_CONDENSED_HEIGHT,
        padding: '0 10px 0 59px',
        display: 'grid',
        gridTemplateColumns: 'max-content auto max-content',
        alignItems: 'stretch',
        gap: '5px',
        backgroundColor: 'var(--zds-background-weaker, #FFFDF9)',
        '@media (min-width: 450px)': {
            height: UNIVERSAL_TOPBAR_HEIGHT,
            padding: '0 20px 0 71px',
            gap: '0',
        },
        '@media (min-width: 1040px)': {
            paddingLeft: '20px',
        },
    }),
    group: css({
        display: 'grid',
        gridAutoFlow: 'column',
        alignItems: 'center',
        justifySelf: 'flex-end',
        gap: '5px',
        '@media (min-width: 450px)': {
            gap: '17px',
        },
    }),
    mainNavigationContent: [
        {
            display: 'flex',
            alignItems: 'stretch',
            marginLeft: 25,
        },
    ],
    logoLinksWrapper: {
        position: 'relative',
    },
    skipLink: {
        position: 'absolute',
        top: '100%',
        whiteSpace: 'nowrap',
    },
});
const TopbarLoadingState = (_a) => {
    var _b;
    var { logoAriaLabel = 'Go to the Zapier Homepage', logoHref = '/', onLogoClick = () => { }, selectedHref = '', shouldRenderHiddenMenu = true, shouldRenderLogo = true, size = 'medium', skipLinkHref = skipLinkHrefDefault, renderAccountMenu = (props) => (jsx(AccountActions, { selectedHref: props.selectedHref, shouldRenderSignIn: props.size !== 'small', shouldRenderSignUp: true, size: props.size })), renderNotifications = () => null, renderSearchForm = (props) => (jsx(SearchForm, { isSearching: props.isSearching, onClose: props.onClose, searchInputId: props.searchInputId })) } = _a, otherProps = __rest(_a, ["logoAriaLabel", "logoHref", "onLogoClick", "selectedHref", "shouldRenderHiddenMenu", "shouldRenderLogo", "size", "skipLinkHref", "renderAccountMenu", "renderNotifications", "renderSearchForm"]);
    const props = Object.assign({ shouldRenderHiddenMenu,
        logoAriaLabel,
        logoHref,
        onLogoClick,
        renderAccountMenu,
        renderNotifications,
        renderSearchForm,
        selectedHref,
        shouldRenderLogo,
        size,
        skipLinkHref }, otherProps);
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const logoSize = {
        width: 105,
        height: 28,
    };
    return (jsx("div", { css: Styles.root, "data-zds": true },
        jsx("div", { css: Styles.header, "data-testid": "universalTopbar-loading-state", "data-zds": true },
            jsx("div", { css: Styles.group, "data-zds": true }, shouldRenderLogo && (jsx("header", { css: Styles.logoLinksWrapper, "data-zds": true },
                jsx("a", { "aria-label": logoAriaLabel, href: getFullyQualifiedURL(logoHref), onClick: onLogoClick, "data-zds": true },
                    jsx(ZapierLogo, Object.assign({}, logoSize))),
                jsx("div", { css: Styles.skipLink, "data-zds": true },
                    jsx(SkipLink, { href: skipLinkHref }))))),
            jsx("div", { css: Styles.mainNavigationContent, "data-zds": true }, shouldRenderHiddenMenu ? (jsx(VisuallyHidden, null,
                jsx("nav", { "aria-label": "Site Links", id: "site-nav", "data-zds": true },
                    jsx("ul", { "data-zds": true }, (_b = FALLBACK_TOP_NAV_RESPONSE === null || FALLBACK_TOP_NAV_RESPONSE === void 0 ? void 0 : FALLBACK_TOP_NAV_RESPONSE.topBarMenu) === null || _b === void 0 ? void 0 : _b.map((link) => (jsx(UniversalTopbarLink, { key: link.text, navigationItem: link }, link.text))))))) : (jsx(Spacer, null))),
            jsx("div", { "aria-label": "Manage your account and search apps", css: Styles.group, role: "form", "data-zds": true }, renderAccountMenu(props)))));
};
export default TopbarLoadingState;
//# sourceMappingURL=TopbarLoadingState.js.map
// @zapier/universal-layout@9.12.4 (a02ac1bd0)
